export default __webpack_public_path__ + "./image/c6d9ebc72733875c971271de057118f4.png";